import React from "react";
import ProfitReport from "./ProfitReport";

// Api/Reports/ItemwiseProfitReport - see ProfitReport.jsx
const ItemWiseProfit = () => <ProfitReport kind="item" />;

export default ItemWiseProfit;
